import { Button, Modal, Typography } from '@analytical-alley/ui';

interface Props {
    onClose: () => void;
    onRetry: () => void;
    error?: Error | null;
    subject: string;
}

export const OptimizationErrorModal = ({
    onClose,
    onRetry,
    error,
    subject,
}: Props) => {
    return (
        <Modal dismissible show onClose={onClose} popup size="lg">
            <Modal.Header>Optimization failed</Modal.Header>
            <Modal.Body>
                <div className="flex flex-col gap-4">
                    <Typography variant="bodyM">
                        We couldn&apos;t finish optimizing {subject}. The
                        optimization engine took too long to respond or ran into
                        an unexpected problem.
                    </Typography>
                    <Typography variant="bodyM">
                        Please try again. If the issue keeps happening, reload
                        the page or contact support.
                    </Typography>
                    {error?.message && (
                        <Typography
                            variant="bodyS"
                            className="text-gray-400 break-words"
                        >
                            {error.message}
                        </Typography>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer className="py-4 gap-2">
                <Button size="sm" color="gray" onClick={onClose}>
                    Close
                </Button>
                <Button size="sm" color="light" onClick={onRetry}>
                    Try again
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
